import React, { Props } from 'react';

import layoutStyles from './layout.module.css';

const Container = ({ children }: Props<unknown>) => (
  <div className={`container ${layoutStyles.container}`}>{children}</div>
);

export default Container;
